import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Flex from 'ui/Flex/Flex';
import oops from '../ErrorBoundary/assets/oops.png';

const StyImage = styled('img', {
    name: 'StyImage',
})({
    objectFit: 'contain',
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
});

function NotFound(): React.ReactElement {
    const { t } = useTranslation();
    return (
        <Flex
            direction="column"
            align="center"
            justify="center"
            sx={{ height: '100%' }}
        >
            <StyImage src={oops} alt="no parachute" />
            <h1>{t('pageNotFound.title')}</h1>
            <div className="message">{t('pageNotFound.description')}</div>
        </Flex>
    );
}

export default NotFound;
